import { format, endOfWeek, startOfWeek } from "date-fns";
import { Fragment, useContext, useMemo, useState } from "react";
import { Button } from "rizzui";
import { PrivilegeContext } from "../../../components/priviledge/PriviledgeProvider";
import { FiltersProvider } from "../../../components/providers/FiltersProvider";
import PageHeader from "../../../layout/shared/page-header";
import { menuRoutes } from "../../../router/menu";
import cn from "../../../utils/classNames";
import StopsList from "./StopsList";

const StopsListWrapper = () => {

    // STATES

    const [isOpen, setIsOpen] = useState(false);
    const [isOpenImport, setIsOpenImport] = useState(false);

    const breadCrumb = [
        { name: 'Administración' },
        { name: 'Gestión de paradas' },
        { name: 'Paradas', href: menuRoutes.stops.path },
    ];

    const defaultFilters = useMemo(() => {
        const now = new Date();
        const weekStart = startOfWeek(now, { weekStartsOn: 1 });
        const weekEnd = endOfWeek(now, { weekStartsOn: 1 });
        return {
            between_dates: {
                startDate: format(weekStart, 'yyyy-MM-dd'),
                endDate: format(weekEnd, 'yyyy-MM-dd'),
                type: 'createdAt' as const,
            },
        };
    }, []);

    // HOOKS

    const { userCan } = useContext(PrivilegeContext);

    // RENDER

    return (
        <Fragment>
            <FiltersProvider defaultFilterFilters={defaultFilters}>
                <PageHeader title="Listado de paradas" breadcrumb={breadCrumb}>
                    {
                        userCan('create', 'preventive_stops') &&
                        (
                            <div className="flex flex-col md:flex-row gap-2">
                                {/*
                                <Button
                                    color="primary"
                                    onClick={() => { setIsOpenImport(true); }}
                                    className={cn(['mt-4 md:mt-0'])}
                                >
                                    Importar paradas
                                </Button>
                                */}
                                <Button
                                    color="primary"
                                    onClick={() => {  setIsOpen(true); }}
                                    className={cn(['mt-4 md:mt-0'])}
                                >
                                    Crear parada
                                </Button>
                            </div>
                        )
                    }

                </PageHeader>
                <StopsList
                    isOpen={isOpen}
                    setIsOpen={setIsOpen}
                    isOpenImport={isOpenImport}
                    setIsOpenImport={setIsOpenImport}
                />
            </FiltersProvider>
        </Fragment>
    );

}

export default StopsListWrapper;
